// `/` redirects to `/accounts` -- there is no Home destination (§3 of the
// frontend proposal).
import { Navigate } from 'react-router-dom';

export function RootRedirect() {
  return <Navigate to="/accounts" replace />;
}

export default RootRedirect;
